<!--
  How to use: set a v-model in the parent.
  Example:
  <pl-input v-model="result"></pl-input>

  Props:

  Optional:
  1) labelText - Set a label for the input
  2) errorMessage - Set an error message to show below the input box
  3) value - If the initial value of the box is sent
             by the parent (useful for editing)
  NOTE: attributes i.e. placeholder can be used as if pl-input was an input tag
  Because we are setting inheritAttrs: false, and v-binding $attrs

 -->
<template lang="html">
  <div class="input-container" v-bind:class="{ prepend: addon }">
    <label class="label-default pl-caption">{{ labelText }}</label>
    <!-- uses object syntax for v-on and v-bind -->
    <div v-if="addon" class="input-group-prepend">
      <i class="fas input-group-text" v-bind:class="`fa-${addon}`"></i>
    </div>
    <input
      ref="input-native-tag"
      @input="updateValue($event.target.value)"
      :value="value"
      :type="type"
      class="bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded"
      :class="[
        centeredText ? 'tc' : null,
        hasError,
        customStyle
          ? customStyle
          : 'bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded',
      ]"
      v-on="listeners"
      v-bind="$attrs"
    />
    <span class="error-message pl-caption">{{ errorMessage }}</span>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        inheritAttrs: false, // needed to stop div wrapper from inheriting attributes i.e placeholder
      };
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: (event) => this.$emit('input', event.target.value),
        };
      },
      hasError() {
        return this.error === true ? 'error' : '';
      },
    },
    props: {
      focusOnMounted: {
        type: Boolean,
        default: false,
      },
      labelText: {
        type: String,
        default() {
          return '';
        },
      },
      errorMessage: {
        type: String,
        default() {
          return '';
        },
      },
      error: {
        type: Boolean,
        default: false,
      },
      value: {
        type: [String, Number, Date],
      },
      addon: {
        type: String,
      },
      type: {
        type: String,
        default() {
          return 'text';
        },
      },
      centeredText: {
        type: Boolean,
        default: false,
      },
      customStyle: {
        type: String,
        default: '',
      },
    },
    methods: {
      updateValue(value) {
        this.$emit('input', value);
      },
    },
    mounted() {
      if (this.focusOnMounted) {
        this.$refs['input-native-tag'].focus();
      }
    },
  };
</script>

<style scoped lang="stylus">

  /****** Import Global Stylus ******/

  @import '~app/global-stylus'

  /****** Defaults ******/

  .default
    position: relative
    width: 100%
    padding: 6px
    outline: none
    border: 2px solid #e1e8ee
    border-radius: 5px
    &:focus
      border-color: pl-primary
  .small-input
    height : 30px !important
    width : 150px  !important
  .error
    border: 2px solid pl-ruby
  .input-container
    padding: 0 12px 0 12px

  .label-default
    padding-left: 3px

  .error-message
    padding-left: 3px
    color: red

  .input-group-prepend
  {
    display:flex
    margin-right: -1px
    .input-group-text {
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      padding: .375rem .75rem;
      margin-bottom: 0;
      font-size: 1rem;
      line-height: 1.5;
      text-align: center;
      white-space: nowrap;
      border-radius: .25rem;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  .prepend {
    border-radius: 25px;
    display: flex;
    input {
      border: none;
    }
  }
</style>



// WEBPACK FOOTER //
// plInput.vue?2b704ead